import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';
import {TravelTypePieChartColorOptionsArray} from '../../constants/finance-dashboard-chart-options';

@Component({
    selector: 'app-gross-fare-by-travel-type',
    templateUrl: './gross-fare-by-travel-type.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class GrossFareByTravelTypeComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Gross Fare by Travel Type',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: TravelTypePieChartColorOptionsArray,
      borderColor: TravelTypePieChartColorOptionsArray,
    };
  }
}
